export default __webpack_public_path__ + "static/media/001-balloon-red.98033a93.svg";